import React, { useEffect, useContext } from 'react';
import { string, object } from 'prop-types';
import { reportAssetShown } from '../../../utils/report/bigquery';
import AppContext from '../../../state/AppContext';
import { pickSlideComponent } from '.';

const SlideWrapper = ({ type, slideProps }) => {
    const storeContext = useContext(AppContext);

    useEffect(() => {
        slideProps.isActive &&
            reportAssetShown(storeContext, {
                resourceId: slideProps.slide.resourceId,
                position: slideProps.index + 1,
            });
    }, [storeContext, slideProps.slide.resourceId, slideProps.index, slideProps.isActive]);

    const SlideComponent = pickSlideComponent(type);

    return SlideComponent ? <SlideComponent {...slideProps} /> : null;
};

SlideWrapper.propTypes = {
    type: string,
    slideProps: object,
};

export default SlideWrapper;
